import React from 'react';
import RegistryFacets from './RegistryFacets';
import {
  fastFacetsDesktopOptimizelyTest,
  fastFacetsMobileOptimizelyTest,
} from '../../util/optimizelyConfigs';
import inOptimizelyExperiment from '../../util/optimizelyHelper';

const inDesktopTest = inOptimizelyExperiment(fastFacetsDesktopOptimizelyTest);
const inMobileTest = inOptimizelyExperiment(fastFacetsMobileOptimizelyTest);
const inEitherTest = inDesktopTest || inMobileTest;
const RegistrySidebar = props => (
  <div className={`col-xs-12 ${inEitherTest ? null : 'col-md-3'} col-lg-2`}>
    <RegistryFacets {...props} />
  </div>
);

export default RegistrySidebar;



// WEBPACK FOOTER //
// ./src/components/registry/RegistrySidebar.jsx